import styled, { css } from 'styled-components';
import { em } from '../../styles';
import { typographyStyle } from '../../components/_shared/Typography';
import { Link } from '../../components/_shared/Link';

export const PageWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: ${em(22)};
`;

export const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  width: 100%;
`;

export const RightBlock = styled.div`
  flex: 1;
  padding: 20px;
  border-radius: 10px;
`;
export const LogItem = styled.div`
  padding: 10px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin-bottom: 10px;
  cursor: pointer;
`;

export const LogDetails = styled.div`
  margin-top: 8px;
  padding-left: 10px;
  color: #444;
`;

export const EmptyMessage = styled.div`
  text-align: center;
`;
